// @flow
import { type SuggestionResult } from "../typeDefinitions/suggestionsResult";
import {
    GET_SEARCH_SUGGESTIONS_REQUEST,
    GET_SEARCH_SUGGESTIONS_SUCCESS,
    GET_SEARCH_SUGGESTIONS_FAILURE, CLEAR_SEARCH_SUGGESTIONS,
} from "../actions/actionTypes";

type State = {
    +isFetching: boolean,
    +suggestions: Array<any>
};

type Action = {
    type: string,
    response: SuggestionResult
};

const initState: State = {
    isFetching: false,
    suggestions: []
};

const searchSuggestionsReducer = (state: State = initState, action: Action): State => {
    switch (action.type) {
        case GET_SEARCH_SUGGESTIONS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_SEARCH_SUGGESTIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                suggestions: action.response.results
            });
        case GET_SEARCH_SUGGESTIONS_FAILURE:
            return Object.assign({}, state, initState);
        case CLEAR_SEARCH_SUGGESTIONS:
            return Object.assign({}, state, {
                suggestions: [],
            });
        default:
            return state;
    }
};

export default searchSuggestionsReducer;
